import { render, staticRenderFns } from "./HealthInfo.vue?vue&type=template&id=0861803e&scoped=true&"
import script from "./HealthInfo.vue?vue&type=script&lang=js&"
export * from "./HealthInfo.vue?vue&type=script&lang=js&"
import style0 from "./HealthInfo.vue?vue&type=style&index=0&id=0861803e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861803e",
  null
  
)

export default component.exports